module.exports = __webpack_public_path__ + "media/images/icons/exit-icon-64a102c2ba2b68d0a0037f4058cc4e67.svg";